"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgRollawayBed = function SvgRollawayBed(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rollaway-bed_svg__a",
    x: 10,
    y: 4,
    width: 12,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "rollaway-bed_svg__b",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 12,
    height: 6,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rollaway-bed_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.486 6.722 6.5 6.514a5.953 5.953 0 0 0-.223-.576l-.081-.184a3.487 3.487 0 0 1-.08-.198c-.243-.666-.795-1.58-1.654-2.714a1 1 0 0 0-1.14-.335l-.35.127a.85.85 0 0 0-.514 1.074l1.028 3.014z",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 2.5,
    y: 7.5,
    width: 8,
    height: 5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 10.5,
    y: 7.5,
    width: 11,
    height: 5,
    rx: 2
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#4A4A4A",
    mask: "url(#rollaway-bed_svg__b)",
    strokeWidth: 2,
    strokeDasharray: 1,
    transform: "rotate(-30 16 7)",
    xlinkHref: "#rollaway-bed_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h3v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1zm5 0h3v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1zm10 0h3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1z",
    fill: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgRollawayBed);
var _default = exports["default"] = Memo;